module.exports = __webpack_public_path__ + "media/images/header__bg-358933fbf9d367835cce9b96d67a2c10.jpg";